import { BasicUser } from "../basic-user";
import { ActionHistory } from "./action-history";
import { StandardQuestionEntry } from "./standard-question-entry";

export class ComplianceAction{
    public ActionID: number = -1;
    public ActionOwner: BasicUser = new BasicUser();
    public ActionOwnerTypeID: number = -1;
    public ReportingUserID: number = -1;
    public StandardAction:StandardQuestionEntry =  new StandardQuestionEntry();
    public ActionNote: string = "";
    public Display:boolean = false;
    //public AdditionalUserIDs: number[];
    //public AdditionalPeopleInvolved: string;
    public ActionDeadline: Date = new Date();
    public Editing:boolean = false;
    public ParentActionID: number = -1;
    public EventID:number = -1;
    public LocationID:number = -1;
    public ActionTypeID:number = -1;
    public AuditResultDetailID:number = -1;
    public ActionVariationID:number = 1;
    public AuditID:number = -1;
    public EventSummary:string = "";
    constructor(values: Object = {}){
        Object.assign(this, values);
        if(values.hasOwnProperty('ActionDeadline')){
            const rawDeadline = (values as { ActionDeadline?: Date | string | null })['ActionDeadline'];
            const parsedDeadline = rawDeadline ? new Date(rawDeadline) : null;
            this.ActionDeadline = parsedDeadline && !isNaN(parsedDeadline.getTime()) && parsedDeadline.getFullYear() >= 2000
                ? parsedDeadline
                : new Date();
        }
        if(values.hasOwnProperty('ActionOwner')){
            this.ActionOwner = new BasicUser((values as ComplianceAction)['ActionOwner'] as BasicUser) 
         }    
         if(values.hasOwnProperty('StandardAction')){
            this.StandardAction = new StandardQuestionEntry((values as ComplianceAction)['StandardAction'] as StandardQuestionEntry)
         } 

    }
}
